import { render, staticRenderFns } from "./FeeTypes.vue?vue&type=template&id=0a1bceac&scoped=true"
import script from "./FeeTypes.vue?vue&type=script&lang=js"
export * from "./FeeTypes.vue?vue&type=script&lang=js"
import style0 from "./FeeTypes.vue?vue&type=style&index=0&id=0a1bceac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1bceac",
  null
  
)

export default component.exports